'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var userFavoritesInit = exports.userFavoritesInit = undefined;

exports.userFavoritesInit = userFavoritesInit = function userFavoritesInit(refs) {
    var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

    var t = this;

    var appManager = refs.appManager,
        requestManager = refs.requestManager,
        instanceManager = refs.instanceManager;

    var apiPath = appManager.getApiPath(),
        username = appManager.userAccount.userCredentials.username,
        eventType = instanceManager.dataStatisticsEventType;

    return {
        baseUrl: apiPath + '/dataStatistics/favorites.json',
        params: ['eventType=' + eventType, 'username=' + username, 'pageSize=' + pageSize],
        success: function success(response) {
            appManager.userFavorites = response;
            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=userFavoritesInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/userFavoritesInit.js
 ** module id = 140
 ** module chunks = 0 1
 **/